// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__98gTJ","content":"Button_content__wtKp9"};